import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { RefSystemeIrrigation } from 'src/app/data/declaration/models/ref-systeme-irrigation.model';
import { RefSystemeIrrigationService } from 'src/app/data/declaration/services/parcellaire/ref-systeme-irrigation.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-edit-systeme-irrigation',
    templateUrl: './edit-systeme-irrigation.component.html',
    styleUrls: ['./edit-systeme-irrigation.component.scss'],
    standalone: false
})
export class EditSystemeIrrigationComponent implements OnInit {
    formGroup: UntypedFormGroup;
    creation = false;
    title: string;
    irrigation: RefSystemeIrrigation;

    get code() {
        return this.formGroup.get('code');
    }
    get libelle() {
        return this.formGroup.get('libelle');
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly loaderService: LoaderService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly irrigationService: RefSystemeIrrigationService
    ) {}

    ngOnInit() {
        const id = parseInt(this.route.snapshot.paramMap.get('id'), 10);

        if (!id) {
            this.creation = true;
        }
        this.loadData(id);
    }

    loadData(id: number) {
        this.title = this.creation ? 'page.valeur_parametrable.form.title.add_irrigation' : 'page.valeur_parametrable.form.title.edit_irrigation';

        if (this.creation) {
            this.irrigation = new RefSystemeIrrigation();
            this.initForm(null);
        } else {
            this.irrigationService
                .getRefSystemeIrrigation()
                .pipe(this.loaderService.operator())
                .subscribe(irrigations => {
                    this.irrigation = irrigations.find(g => g.id === id);
                    this.initForm(this.irrigation && this.irrigation.id ? this.irrigation : null);
                });
        }
    }

    private initForm(irrigation?: RefSystemeIrrigation): void {
        this.formGroup = this.fb.group({
            code: [{ value: irrigation ? irrigation.code : undefined, disabled: false }, Validators.required],
            libelle: [{ value: irrigation ? irrigation.libelle : undefined, disabled: false }, Validators.required]
        });
    }

    submit() {
        if (this.formGroup.valid) {
            this.irrigation.code = this.code.value;
            this.irrigation.libelle = this.libelle.value;

            if (this.irrigation.id == null) {
                this.irrigationService.creerRefSystemeIrrigation(this.irrigation).subscribe(idIrrigation => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            } else {
                this.irrigationService.modifierRefSystemeIrrigation(this.irrigation).subscribe(() => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            }
        }
    }
}
